export default __webpack_public_path__ + "static/media/automationRulesExample.8e205e7c.png";